import React, { useState, useEffect } from "react";
import { API_URL } from '../../../config';

function TauxConversion({ percentage = 50, label = "Taux de conversion", iconClass = "fas fa-hands-helping" }) {
  const [conversionRate, setConversionRate] = useState(null); // Taux de conversion
  const [, setTotalUsers] = useState(0); // Nombre total d'utilisateurs
  const [, setUsersWithAnnouncements] = useState(0); // Utilisateurs ayant posté des annonces
  const [, setLoading] = useState(true); // État de chargement
  const [, setError] = useState(null); // État des erreurs
  useEffect(() => {
    // Fonction pour récupérer les données du taux de conversion
    const fetchConversionRate = async () => {
      try {
        setLoading(true); // Active l'indicateur de chargement
        const token = localStorage.getItem("token"); // Récupère le token depuis le localStorage

        const response = await fetch(`${API_URL}/api/annonce/getconversionrate`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`, // Ajoute le token au header Authorization
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          // Vérifie si la réponse HTTP est correcte
          throw new Error(`Erreur : ${response.status} ${response.statusText}`);
        }

        const data = await response.json(); // Convertit la réponse en JSON

        if (data.status === 0) {
          // Met à jour les états avec les données récupérées
          setConversionRate(data.conversionRate);
          setTotalUsers(data.totalUsers);
          setUsersWithAnnouncements(data.usersWithAnnouncements);
        } else {
          throw new Error(data.message || "Erreur lors de la récupération des données");
        }
      } catch (err) {
        setError(err.message); // Gère les erreurs
      } finally {
        setLoading(false); // Désactive l'indicateur de chargement
      }
    };

    fetchConversionRate();
  }, []); // Le tableau vide [] garantit que l'effet ne s'exécute qu'une fois

  return (
    <div className="col-md-6 col-xl-3 mb-4">
      <div className="card shadow border-start-info py-2">
        <div className="card-body">
          <div className="row align-items-center no-gutters">
            <div className="col me-2">
              <div className="text-uppercase text-info fw-bold text-xs mb-1">
                <span>{label}</span>
              </div>
              <div className="row g-0 align-items-center">
                <div className="col-auto">
                  <div className="text-dark fw-bold h5 mb-0 me-3">
                    <span>{conversionRate?conversionRate:0}%</span>
                  </div>
                </div>
                <div className="col">
                  <div className="progress progress-sm">
                    <div
                      className="progress-bar bg-info"
                      role="progressbar"
                      aria-valuenow={conversionRate?conversionRate:0}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: `${conversionRate?conversionRate:0}%` }}
                    >
                      <span className="visually-hidden">{conversionRate?conversionRate:0}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <i className={`${iconClass} fa-2x text-gray-300`}></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TauxConversion;
